class MobNavToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function(e){
      e.preventDefault();
      var slideOut = this.nextElementSibling;
      var wrapper = document.querySelector('.mob_nav__wrapper');

      wrapper.scrollTop = 0;
      wrapper.classList.add('overlay');

      if (slideOut) {
        slideOut.classList.add('open');
      }
    });
  }
}

customElements.define("mob-nav-toggle", MobNavToggle);